import { Component, OnInit } from '@angular/core';
import { SubsetModel } from '@models/subset.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggingService } from '@services/logging.service';
import { SearchStrategyService } from '@services/search-strategy.service';
import { SubsetService } from '@services/subset.service';
import { ResultMessage } from '@shared/_constants';
import { Subject } from 'rxjs';
import { SubsetDialogMode } from '../../../../_study_constants';
/*import _ from 'lodash-es';*/

@Component({
  selector: 'app-subset-dialog',
  templateUrl: './subset-dialog.component.html',
  styleUrls: ['./subset-dialog.component.css'],
  providers: [SubsetService, SearchStrategyService],
})
export class SubsetDialogComponent implements OnInit {
  newSubsetName: string;
  subsetID: number;
  searchStrategyId: number;
  allSubsets: SubsetModel[];
  subsetIds: number[];
  screenType: SubsetDialogMode;
  private _success = new Subject<string>();
  invalidSubset: boolean;
  type = 'success';
  showLoader = false;
  subsetDialogMode = SubsetDialogMode;
  validationMessage = 'Please enter a valid Subset';

  constructor(
    private activeModal: NgbActiveModal,
    private logger: LoggingService,
    private searchStrategyService: SearchStrategyService,
    private subsetService: SubsetService
  ) {}

  async ngOnInit() {
    try {
      this.showLoader = true;
      this.searchStrategyId = this.searchStrategyService.studySearchStrategy.studySearchStrategyId;
    } finally {
      this.showLoader = false;
    }
  }

  close() {
    this.activeModal.close();
  }

  public async saveSubset(): Promise<void> {
    try {
      this.showLoader = true;
      if (await this.validateSubset()) {
        try {
          const subset: SubsetModel = new SubsetModel();
          subset.bdMatrixSubsetId = this.subsetID;
          subset.studySearchStrategyId = this.searchStrategyId;
          subset.comparableIds = [];

          if (this.screenType === SubsetDialogMode.AddToExistingSubset || this.screenType == SubsetDialogMode.RemoveFromSubset) {
            const filterSubset = this.allSubsets.find((fil) => fil.bdMatrixSubsetId === this.subsetID);
            subset.subsetName = filterSubset.subsetName;
          } else {
            subset.subsetName = this.newSubsetName;
          }

          this.activeModal.close(subset);
        } catch (e) {
          this.logger.error(this.constructor.name, 'SaveComments', e);

          this._success.next(ResultMessage.UnexpectedError);
          this.type = 'danger';
        }
      }
    } finally {
      this.showLoader = false;
    }
  }

  private async validateSubset(): Promise<boolean> {
    this.invalidSubset = false;
    this.validationMessage = 'Please enter a valid Subset';

    if (this.screenType === SubsetDialogMode.RemoveFromSubset) {
      this.invalidSubset = this.invalidRemoveFromSubset();
    } else if (this.screenType === SubsetDialogMode.AddToExistingSubset) {
      this.invalidSubset = this.invalidAddToExistingSubset();
    } else {
      this.invalidSubset = await this.invalidAddNewSubset();
    }

    return !this.invalidSubset;
  }

  private invalidRemoveFromSubset(): boolean {
    if (this.subsetID === undefined || this.subsetID == null || this.subsetID <= 0) {
      return true;
    } else {
      const canBeRemoved = this.subsetIds.length === 1 && this.subsetIds[0] === this.subsetID;
      if (!canBeRemoved) {
        this.validationMessage = 'The selected companies have different subsets, thus the subsets cannot be bulk removed';
        return true;
      }
    }
    return false;
  }

  private invalidAddToExistingSubset(): boolean {
    return this.subsetID === undefined || this.subsetID == null || this.subsetID <= 0;
  }

  private async invalidAddNewSubset(): Promise<boolean> {
    if (this.newSubsetName === undefined || this.newSubsetName == null || this.newSubsetName.trim() === '') {
      return true;
    } else {
      //Client side duplicate check for subsetname
      const isSubsetNameDuplicate = this.allSubsets.find((fil) => fil.subsetName.toUpperCase() === this.newSubsetName.toUpperCase());
      if (isSubsetNameDuplicate && isSubsetNameDuplicate.bdMatrixSubsetId > 0) {
        this.validationMessage = this.newSubsetName + ' already exists in this study. Please enter a unique name.';
        return true;
      } else {
        //Server side duplicate check for subsetname
        const subset: SubsetModel = new SubsetModel();
        subset.bdMatrixSubsetId = this.subsetID;
        subset.comparableIds = [];
        subset.subsetName = this.newSubsetName;
        subset.studySearchStrategyId = this.searchStrategyId;

        const isDuplicate = await this.subsetService.isSubsetNameDuplicate(subset);
        if (isDuplicate) {
          this.validationMessage = this.newSubsetName + ' already exists in this study. Please enter a unique name.';
          return true;
        }
      }
    }

    return false;
  }
}
